/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import trim from 'lodash/fp/trim.js';
import React, { Fragment } from 'react';
import { Label } from 'reactstrap';
import { Field } from 'redux-form';
import {
  required,
  sameAsNewPassword,
} from '@hbrisk/sp3-risk-model-support/utility/form/validation/fieldValidators/index.js';
import { FieldFeedback, RenderInput } from '#components/support/forms/utility/index.js';

type Props = {|
  form: string,
|};

const ConfirmPasswordField = ({ form }: Props): Element<typeof Fragment> => (
  <>
    <Label htmlFor="confirmPassword">Confirm Password</Label>
    <Field
      id="confirmPassword"
      name="confirmPassword"
      type="password"
      component={RenderInput}
      validate={[required, sameAsNewPassword]}
      normalize={trim}
    />
    <FieldFeedback name="confirmPassword" form={form} />
  </>
);

export default ConfirmPasswordField;
